import(/* webpackMode: "eager" */ "/app/app/(main)/privacypolicy/layout.js");
